import {
  Settings,
  ShieldCheck,
  Building2,
  CalendarClock,
  UserPlus,
  Radio,
  Mail,
  FileBarChart,
  Plug,
  Scale,
  CircleDot,
  PenLine,
  ListChecks,
  FolderTree,
  Gauge,
  Image,
  ArrowLeftRight,
  ClipboardCheck,
  Shuffle,
  GitBranch,
  Timer,
  LayoutList,
  MinusCircle,
  Send,
  Bookmark,
  BookOpen,
  WifiOff,
  TrendingUp,
  Languages,
  Bot,
  Camera,
  AppWindow,
  Maximize,
  Smartphone,
  Lock,
  ScanFace,
  Video,
  BellRing,
  Shield,
  LayoutDashboard,
  Ticket,
  MonitorCheck,
  Monitor,
  Save,
  Award,
  KeyRound,
  BarChart3,
  ScrollText,
  Calculator,
  FileSearch,
  Users,
  CheckSquare,
  Percent,
  RotateCcw,
  Upload,
  Trophy,
  type LucideIcon,
} from "lucide-react";

export type OesFeatureIcon =
  | "exam-config"
  | "user-roles"
  | "institution"
  | "scheduling"
  | "bulk-register"
  | "live-monitor"
  | "notifications"
  | "reports"
  | "api"
  | "audit"
  | "mcq"
  | "descriptive"
  | "question-types"
  | "categories"
  | "difficulty"
  | "media"
  | "import-export"
  | "review"
  | "random-pool"
  | "version"
  | "timer"
  | "sections"
  | "shuffle"
  | "negative-marking"
  | "auto-submit"
  | "mark-review"
  | "practice"
  | "offline"
  | "adaptive"
  | "language"
  | "ai-proctor"
  | "webcam"
  | "tab-switch"
  | "fullscreen"
  | "device-lock"
  | "browser-lock"
  | "identity"
  | "recording"
  | "alerts"
  | "secure-delivery"
  | "dashboard"
  | "hall-ticket"
  | "compat-check"
  | "exam-interface"
  | "autosave"
  | "results"
  | "answer-key"
  | "analytics"
  | "certificate"
  | "mobile"
  | "auto-grade"
  | "manual-eval"
  | "rubric"
  | "moderation"
  | "result-processing"
  | "revaluation"
  | "publish"
  | "statistics"
  | "export"
  | "merit";

export const oesFeatureIconMap: Record<OesFeatureIcon, LucideIcon> = {
  "exam-config": Settings,
  "user-roles": ShieldCheck,
  institution: Building2,
  scheduling: CalendarClock,
  "bulk-register": UserPlus,
  "live-monitor": Radio,
  notifications: Mail,
  reports: FileBarChart,
  api: Plug,
  audit: Scale,
  mcq: CircleDot,
  descriptive: PenLine,
  "question-types": ListChecks,
  categories: FolderTree,
  difficulty: Gauge,
  media: Image,
  "import-export": ArrowLeftRight,
  review: ClipboardCheck,
  "random-pool": Shuffle,
  version: GitBranch,
  timer: Timer,
  sections: LayoutList,
  shuffle: Shuffle,
  "negative-marking": MinusCircle,
  "auto-submit": Send,
  "mark-review": Bookmark,
  practice: BookOpen,
  offline: WifiOff,
  adaptive: TrendingUp,
  language: Languages,
  "ai-proctor": Bot,
  webcam: Camera,
  "tab-switch": AppWindow,
  fullscreen: Maximize,
  "device-lock": Smartphone,
  "browser-lock": Lock,
  identity: ScanFace,
  recording: Video,
  alerts: BellRing,
  "secure-delivery": Shield,
  dashboard: LayoutDashboard,
  "hall-ticket": Ticket,
  "compat-check": MonitorCheck,
  "exam-interface": Monitor,
  autosave: Save,
  results: Award,
  "answer-key": KeyRound,
  analytics: BarChart3,
  certificate: ScrollText,
  mobile: Smartphone,
  "auto-grade": Calculator,
  "manual-eval": PenLine,
  rubric: CheckSquare,
  moderation: Users,
  "result-processing": Percent,
  revaluation: RotateCcw,
  publish: Upload,
  statistics: BarChart3,
  export: ArrowLeftRight,
  merit: Trophy,
};
